<div class="pdf-review-container">
	<div class="pdf-wrapper">
		<div *ngIf="loading && isAvailable" class="pdf-loading-overlay">
			Loading PDF ...
		</div>
		<ngx-extended-pdf-viewer 
			#ngxExtendedPdfViewerComponent 
			*ngIf="isAvailable && !loading" 
			[page]="pdfPage"
			[src]="src" 
			[textLayer]="true" 
			[zoom]="'75%'" 
			(currentZoomFactor)="handleZoomChange($event)"
			[showFindButton]="true" 
			[sidebarVisible]="false" 
			[useBrowserLocale]="true" 
			[handTool]="true"
			[height]="getPdfReviewHeight()" 
			[showHandToolButton]="true" 
			[showBookmarkButton]="false"
			(pagesLoaded)="handlePagesLoaded($event)"
			[zoom]="150"
			>
		</ngx-extended-pdf-viewer>
		<div *ngIf="!isAvailable" class="pdf-unavailable text-center">
			PDF Unavailable
		</div>
	</div>
</div>